import { AvailableModules } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

interface Props {
  onClose: () => void
  isOpen?: boolean
}

const LegacyPlanHintModal = ({ onClose, isOpen = true }: Props) => {
  const benefits = [
    i18n.t('product_updates.upgrade_legacy_plan.modal.first_item.title'),
    i18n.t('product_updates.upgrade_legacy_plan.modal.second_item.title'),
    i18n.t('product_updates.upgrade_legacy_plan.modal.third_item.title'),
    i18n.t('product_updates.upgrade_legacy_plan.modal.fourth_item.title'),
  ]

  return (
    <UpsellingKit.ProductModal
      moduleRequested={AvailableModules.documents}
      requestSource="marketplace-legacy-apps"
      requestReason={ValidReasons.UpgradeFromLegacy}
      pageSource="marketplace-legacy-apps"
      isOpen={isOpen}
      onClose={onClose}
      title={i18n.t('product_updates.upgrade_legacy_plan.modal.description')}
      benefits={benefits}
      openFromUpsellButton={false}
    />
  )
}

export default LegacyPlanHintModal
